import { useState } from "react";
import { CalendarPlus, Check } from "lucide-react";
import { SecondaryButton, CtaButton } from "./kit";

const tomorrow = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export const AddToCalendar = ({ added, busy, onAdd, testId = "add-to-calendar" }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(tomorrow);

  if (added) {
    return (
      <span className="inline-flex items-center gap-1.5 text-[12px] font-bold text-[#4B7B4F] px-3 py-1.5" data-testid={`${testId}-added`}>
        <Check size={13} strokeWidth={2.2} /> On calendar
      </span>
    );
  }
  return open ? (
    <span className="inline-flex items-center gap-1.5" data-testid={`${testId}-picker`}>
      <input type="date" className="field-input !w-[8.5rem] !py-1.5 !px-2 text-[12px] font-mono-j" value={date}
        onChange={(e) => setDate(e.target.value)} data-testid={`${testId}-date`} />
      <CtaButton className="!py-1.5 !px-3 text-[12px]" disabled={busy || !date}
        onClick={async () => { await onAdd(date); setOpen(false); }} data-testid={`${testId}-confirm`}>
        {busy ? "Adding…" : "Add"}
      </CtaButton>
      <button className="text-[12px] text-[#9A9591] hover:text-[#181621] px-1" onClick={() => setOpen(false)} data-testid={`${testId}-cancel`}>Cancel</button>
    </span>
  ) : (
    <SecondaryButton className="!py-1.5 !px-3 text-[12px]" disabled={busy} onClick={() => setOpen(true)} data-testid={`${testId}-btn`}>
      <CalendarPlus size={12} strokeWidth={1.8} /> Add to calendar
    </SecondaryButton>
  );
};
